import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';

class frontOfficeStore {

    // Main Properties

    @observable frontOfficeItems = [];
    @observable frontOfficePendingOrder = undefined;
    @observable frontOfficeRemark = '';

    // FrontOffice Confirm

    @observable frontOfficeTimeSelected = 'now';
    @observable frontOfficeTimeDeliver = '';
    @observable frontOfficeTimeDeliverDate = '';

    // Initialization

    @action initGetFrontOffices() {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.FrontOffices.apiGetFrontOffices(languageCode).then((frontOfficeResponses) => {
            if (frontOfficeResponses) {
                that.frontOfficeItems = frontOfficeResponses.items;
            } else {
                that.frontOfficeItems = [];
            }
        });
    }

    @action refreshFrontOffices() {
        const that = this;
        that.frontOfficeItems = [];

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.FrontOffices.apiGetFrontOffices(languageCode).then((frontOfficeResponses) => {
            if (frontOfficeResponses) {
                that.frontOfficeItems = frontOfficeResponses.items;
            }
        });
    }

    @action initFrontOfficeConfirm() {
        this.frontOfficeRemark = '';
        this.frontOfficeTimeSelected = 'now';
        this.frontOfficeTimeDeliver = '';

        this.frontOfficePendingOrder = this.frontOfficeItems.find(frontOfficeItem => frontOfficeItem.isSelected === true);
        return this.frontOfficePendingOrder;
    }

    // GET Properties

    @action getFrontOfficePendingOrder() {
        return this.frontOfficeItems.find(frontOfficeItem => frontOfficeItem.isSelected === true);;
    }

    // Set Properties

    @action setFrontOfficeIsSelected(taskId, isSelected) {
        this.frontOfficeItems.map(frontOfficeItem => {
            return frontOfficeItem.isSelected = false;
        });

        const frontOfficeItem = this.frontOfficeItems.find(x => x.taskId === taskId);
        frontOfficeItem.isSelected = isSelected;
    }

    @action setFrontOfficeRemark(value) {
        this.frontOfficeRemark = value;
    }

    @action setFrontOfficeTimeSelected(value) {
        this.frontOfficeTimeSelected = value;
        this.frontOfficeTimeDeliver = '';
    }

    @action setFrontOfficeTimeDeliver(value) {
        this.frontOfficeTimeDeliver = value;
        this.frontOfficeTimeSelected = '';
    }

    @action setFrontOfficeTimeDeliverDate(value) {
        this.frontOfficeTimeDeliverDate = value;
    }

    // RESET Properties

    @action resetFrontOffices() {
        this.frontOfficeItems = [];
    }
}

export default new frontOfficeStore()